import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import TmsIntegrationForm from "./TmsIntegrationForm";

const integrationEditEndpoint = ApiEndpoints.tmsIntegration.integrationEdit;
const integrationUpdateEndpoint = ApiEndpoints.tmsIntegration.integrationUpdate;

export default function EditTmsIntegration() {
  const navigate = useNavigate();
  const { integration_id } = useParams();
  const [integration, setIntegration] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${integrationEditEndpoint}${integration_id}`);
        setIntegration(response?.integration || {});
      } catch (error) {
        console.error("Error fetching integration data:", error);
      }
    };
    fetchData();
  }, [integration_id]);

  const handleSubmit = async (formData) => {
    try {
      const response = await ApiRequest("POST", integrationUpdateEndpoint + integration_id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      response.error ? toast.error(response.message) : toast.success(response.message);
      if (!response.error) navigate("/tms-integration");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: "TMS Integration",
    user: "Admin",
    innerpage: "TMS Integration / Edit Integration"
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <TmsIntegrationForm formId="tmsIntegrationEdit" initialData={integration} onSubmit={handleSubmit} />
        <button type="submit" form="tmsIntegrationEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
